import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import ViewOnGoogleMaps from '@/routes/map/ViewOnGoogleMaps.tsx';
import { PopupCoordinates, PopupField } from '@/routes/map/PopupField.tsx';
import { UtilityPole, X } from 'lucide-react';


export interface EiaTransmissionPopupProps {
	longitude: number;
	latitude: number;
	properties: Record<string, string>;
	onClose: () => void;
}

interface EiaTransmissionData {
	type: string;
	status: string;
	owner: string;
	voltClass: string;
	sub1: string;
	sub2: string;
	id: string
}

export function EiaTransmissionPopup({ longitude, latitude, properties, onClose }: EiaTransmissionPopupProps) {
	const transmissionData: EiaTransmissionData = {
		type: properties.TYPE || '',
		status: properties.STATUS || '',
		owner: properties.OWNER || '',
		voltClass: properties.VOLT_CLASS || '',
		sub1: properties.SUB_1 || '',
		sub2: properties.SUB_2 || '',
		id: properties.ID || '',
	}
	return (
		<Card className="bg-white dark:bg-slate-900 border shadow-lg min-w-[260px] max-w-[350px]">
			<CardHeader className="pb-2">
				<div className="flex items-center justify-between">
					<CardTitle className="flex items-center gap-2 text-sm">
						<UtilityPole className="h-4 w-4" />
						EIA Transmission
					</CardTitle>
					<Button aria-label="close" variant="ghost" size="icon" onClick={onClose} className="h-6 w-6">
						<X className="h-3 w-3" />
					</Button>
				</div>
			</CardHeader>
			<CardContent className="space-y-3">
				<PopupCoordinates longitude={longitude} latitude={latitude} />
				<PopupField label="ID" value={transmissionData.id} />
				<PopupField label="Line type" value={transmissionData.type} />
				<PopupField label="Operational status" value={transmissionData.status} />
				<PopupField label="Owner" value={transmissionData.owner} />
				<PopupField label="Voltage classification" value={transmissionData.voltClass} />
				<PopupField label="Substation 1" value={transmissionData.sub1} />
				<PopupField label="Substation 2" value={transmissionData.sub2} />
				<ViewOnGoogleMaps latitude={latitude} longitude={longitude} />
			</CardContent>
		</Card>
);
}

